import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "M4.186 14.085c-.27 0-.52-.14-.66-.39-.07-.12-1.62-2.99-1.62-5.69.01-3.36 2.74-6.09 6.09-6.09a6.09 6.09 0 0 1 6.08 6.08c0 2.7-1.55 5.57-1.62 5.69-.2.36-.66.5-1.02.3a.754.754 0 0 1-.282-1.056c.165-.323 1.412-2.77 1.412-4.934 0-2.53-2.06-4.58-4.58-4.58s-4.57 2.06-4.57 4.58c0 2.262 1.361 4.84 1.428 4.965l.002.005c.2.36.06.82-.3 1.02-.11.06-.24.09-.36.09v.01Z" }, null, -1), a = /* @__PURE__ */ e("path", { d: "M6.037 13.195h-.005a.745.745 0 0 0 .694-1.02l-1.04-2.59a.737.737 0 0 0-.97-.42c-.39.15-.57.59-.42.97l1.04 2.59a.76.76 0 0 0 .696.47h-.005.01Zm3.953 0h.005-.01.006Zm-.275-.05a.758.758 0 0 0 .97-.42l1.04-2.6a.753.753 0 0 0-.42-.97.753.753 0 0 0-.97.42l-1.04 2.6c-.15.38.04.82.42.97Z" }, null, -1), l = [
  n,
  a
];
function s(h, r) {
  return t(), c("svg", o, [...l]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
